(function() {
  if (window.AstPdpSections) {
    window.AstPdpSections.initAll(document);
    return;
  }

  function money(cents, currency) {
    try {
      return (Number(cents) / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      });
    } catch (error) {
      return 'R$ ' + (Number(cents) / 100).toFixed(2).replace('.', ',');
    }
  }

  function toast(root, message) {
    var node = document.createElement('div');
    node.className = 'azp-toast';
    node.textContent = message;
    root.appendChild(node);
    setTimeout(function() { node.classList.add('is-visible'); }, 20);
    setTimeout(function() {
      node.classList.remove('is-visible');
      setTimeout(function() { node.remove(); }, 400);
    }, 2200);
  }

  function initHero(root) {
    if (!root || root.dataset.azpReady === 'true') return;
    root.dataset.azpReady = 'true';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-azp-variants]').textContent);
    } catch (error) {
      variants = [];
    }

    var currency = root.dataset.currency || 'BRL';
    var pixDiscount = Number(root.dataset.pixDiscount || 0);
    var stockFallback = root.dataset.stockFallback || 'Poucas pecas restantes';
    var lowStockThreshold = Number(root.dataset.lowStockThreshold || 12);
    var variantSelect = root.querySelector('[data-azp-variant-select]');
    var stickySelect = root.querySelector('[data-azp-sticky-select]');
    var addButton = root.querySelector('[data-azp-add-btn]');
    var buyButton = root.querySelector('[data-azp-buy-now]');
    var stickyButton = root.querySelector('[data-azp-sticky-submit]');
    var form = root.querySelector('.azp-form-el');

    function pix(cents) {
      return Math.round(Number(cents) * (100 - pixDiscount) / 100);
    }

    function selectedOptions() {
      var groups = root.querySelectorAll('[data-azp-option-group]');
      var options = [];
      groups.forEach(function(group) {
        var checked = group.querySelector('[data-azp-option-input]:checked');
        options[Number(group.dataset.optionIndex)] = checked ? checked.value : '';
      });
      return options;
    }

    function variantByOptions() {
      var options = selectedOptions();
      return variants.find(function(variant) {
        return variant.options.every(function(value, index) {
          return String(value) === String(options[index]);
        });
      });
    }

    function variantById(id) {
      return variants.find(function(variant) {
        return String(variant.id) === String(id);
      });
    }

    function updateOptionLabels() {
      root.querySelectorAll('[data-azp-option-input]:checked').forEach(function(input) {
        var label = root.querySelector('[data-azp-option-label="' + input.dataset.optionIndex + '"]');
        if (label) label.textContent = input.value;
      });
    }

    function syncRadios(variant) {
      if (!variant) return;
      variant.options.forEach(function(value, index) {
        var input = Array.prototype.find.call(root.querySelectorAll('[data-azp-option-input][data-option-index="' + index + '"]'), function(optionInput) {
          return optionInput.value === String(value);
        });
        if (input) input.checked = true;
      });
      updateOptionLabels();
    }

    function setMediaFromVariant(variant) {
      if (!variant || !variant.image) return;
      var main = root.querySelector('[data-azp-main-image]');
      var sticky = root.querySelector('[data-azp-sticky-image]');
      if (main) main.src = variant.image;
      if (sticky) sticky.src = variant.image;
    }

    function setVariant(variant) {
      if (!variant) return;
      if (variantSelect) variantSelect.value = variant.id;
      if (stickySelect) stickySelect.value = variant.id;

      var available = Boolean(variant.available);
      [addButton, buyButton, stickyButton].forEach(function(button) {
        if (button) button.disabled = !available;
      });

      if (addButton) {
        addButton.textContent = available
          ? (addButton.dataset.addLabel || '+ Adicionar à Sacola')
          : (addButton.dataset.soldOutLabel || 'Indisponivel');
      }
      if (stickyButton) stickyButton.textContent = available ? 'Adicionar à Sacola' : 'Indisponivel';

      var pixPrice = root.querySelector('[data-azp-pix-price]');
      var stickyPrice = root.querySelector('[data-azp-sticky-price]');
      var compare = root.querySelector('[data-azp-compare-price]');
      var base = root.querySelector('[data-azp-base-price]');
      var price2 = root.querySelector('[data-azp-price-2]');
      var price4 = root.querySelector('[data-azp-price-4]');

      if (pixPrice) pixPrice.textContent = money(pix(variant.price), currency);
      if (stickyPrice) stickyPrice.textContent = money(pix(variant.price), currency) + ' no PIX';
      if (compare) {
        var compareValue = variant.compare_at_price || variant.price;
        compare.textContent = money(compareValue, currency);
        compare.hidden = Number(compareValue) <= Number(variant.price);
      }
      if (base) base.textContent = money(variant.price, currency);
      if (price2) price2.innerHTML = money(Math.round(variant.price * .94), currency) + ' <small>' + (price2.dataset.unitLabel || 'cada') + '</small>';
      if (price4) price4.innerHTML = money(Math.round(variant.price * .82), currency) + ' <small>' + (price4.dataset.unitLabel || 'cada') + '</small>';

      var stockText = root.querySelector('[data-azp-stock-text]');
      var stockBar = root.querySelector('[data-azp-stock-bar]');
      if (stockText) {
        if (!available) {
          stockText.textContent = 'Produto indisponivel';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold) {
          stockText.textContent = variant.inventory_quantity + ' pecas restantes';
        } else {
          stockText.textContent = stockFallback;
        }
      }
      if (stockBar) {
        var qty = Number(variant.inventory_quantity || 3);
        stockBar.style.width = Math.max(12, Math.min(72, qty * 6)) + '%';
      }

      setMediaFromVariant(variant);
      document.dispatchEvent(new CustomEvent('azp:variant:change', {
        detail: {
          variantId: String(variant.id),
          variant: variant
        }
      }));
    }

    root.querySelectorAll('[data-azp-option-input]').forEach(function(input) {
      input.addEventListener('change', function() {
        updateOptionLabels();
        setVariant(variantByOptions());
      });
    });

    if (stickySelect) {
      stickySelect.addEventListener('change', function() {
        var variant = variantById(this.value);
        syncRadios(variant);
        setVariant(variant);
      });
    }

    root.querySelectorAll('[data-azp-thumb]').forEach(function(button, index) {
      button.addEventListener('click', function() {
        var main = root.querySelector('[data-azp-main-image]');
        var count = root.querySelector('[data-azp-media-count]');
        root.querySelectorAll('[data-azp-thumb]').forEach(function(item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        if (main) {
          main.src = button.dataset.full;
          main.alt = button.dataset.alt || '';
        }
        if (count) count.textContent = (index + 1) + ' / ' + root.querySelectorAll('[data-azp-thumb]').length;
      });
    });

    var shareButton = root.querySelector('[data-azp-share]');
    if (shareButton) {
      shareButton.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function() {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
          toast(root, 'Link copiado');
        }
      });
    }

    if (stickyButton && form) {
      stickyButton.addEventListener('click', function() {
        if (form.requestSubmit && addButton) form.requestSubmit(addButton);
        else if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    if (buyButton && form) {
      buyButton.addEventListener('click', function() {
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin' })
          .then(function(response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = '/checkout';
            })
            .catch(function() {
              if (form.requestSubmit && addButton) form.requestSubmit(addButton);
              else if (form.requestSubmit) form.requestSubmit();
              else form.submit();
            });
      });
    }

    updateOptionLabels();
    setVariant(variantById(variantSelect ? variantSelect.value : root.dataset.currentVariant));
  }

  function initAccordions(scope) {
    scope.querySelectorAll('[data-azp-accordion]').forEach(function(root) {
      if (root.dataset.azpReady === 'true') return;
      root.dataset.azpReady = 'true';
      root.querySelectorAll('[data-azp-accordion-trigger]').forEach(function(button) {
        button.addEventListener('click', function() {
          var item = button.closest('[data-azp-accordion-item]');
          var open = item.classList.toggle('is-open');
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-azp-carousel]').forEach(function(carousel) {
      if (carousel.dataset.azpReady === 'true') return;
      carousel.dataset.azpReady = 'true';

      var slides = carousel.querySelectorAll('[data-azp-slide]');
      var dots = carousel.querySelectorAll('[data-azp-dot]');
      var active = 0;
      if (!slides.length) return;

      function showSlide(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function(slide, i) { slide.classList.toggle('is-active', i === active); });
        dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === active); });
      }

      var next = carousel.querySelector('[data-azp-next]');
      var prev = carousel.querySelector('[data-azp-prev]');
      if (next) next.addEventListener('click', function() { showSlide(active + 1); });
      if (prev) prev.addEventListener('click', function() { showSlide(active - 1); });
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() { showSlide(Number(dot.dataset.azpDot)); });
      });
      showSlide(0);
    });
  }

  function reviewText(root, selector) {
    var node = selector ? root.querySelector(selector) : root;
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function initialsFromName(name) {
    var parts = String(name || '').replace(/compra verificada/ig, '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return 'AZ';
    return (parts[0].charAt(0) + (parts[1] ? parts[1].charAt(0) : parts[0].charAt(1) || '')).toUpperCase();
  }

  function parseJudgemeRating(review) {
    var rating = Number(review.dataset.rating || review.dataset.score || review.getAttribute('data-rating') || review.getAttribute('data-score'));
    if (!rating) {
      var onStars = review.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm--full, .jdgm-star.jdgm-star--on').length;
      var halfStars = review.querySelectorAll('.jdgm-star.jdgm--half').length;
      rating = onStars + (halfStars ? .5 : 0);
    }
    if (!rating) {
      var label = reviewText(review, '.jdgm-rev__rating') || review.getAttribute('aria-label') || '';
      var match = label.match(/([1-5](?:[.,]\d)?)/);
      rating = match ? Number(match[1].replace(',', '.')) : 5;
    }
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function judgemeReviewData(review) {
    var title = reviewText(review, '.jdgm-rev__title');
    var body = reviewText(review, '.jdgm-rev__body p') || reviewText(review, '.jdgm-rev__body') || reviewText(review, '.jdgm-rev__content');
    var name = reviewText(review, '.jdgm-rev__author') || reviewText(review, '.jdgm-rev__buyer') || 'Cliente Azua';
    var city = reviewText(review, '.jdgm-rev__timestamp') || reviewText(review, '.jdgm-rev__location');
    var verified = Boolean(review.querySelector('.jdgm-rev__buyer-badge, .jdgm-rev__verified-buyer, .jdgm-verified-badge'));

    name = name.replace(/compra verificada/ig, '').replace(/verified buyer/ig, '').trim() || 'Cliente Azua';
    if (!title && !body) return null;

    return {
      rating: parseJudgemeRating(review),
      title: title,
      body: body,
      name: name,
      city: city,
      initials: initialsFromName(name),
      verified: verified
    };
  }

  function appendReviewText(parent, tag, className, text) {
    if (!text) return null;
    var node = document.createElement(tag);
    node.className = className;
    node.textContent = text;
    parent.appendChild(node);
    return node;
  }

  function buildReviewCard(data) {
    var article = document.createElement('article');
    article.className = 'azp-review-card';
    article.setAttribute('data-azp-review-card', '');

    // Aspa decorativa de fundo
    var quoteIconBg = document.createElement('div');
    quoteIconBg.className = 'quote-icon-bg';
    quoteIconBg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" fill="none"><path d="M0 22V12H6C6 8.5 5 6 3 4.5L5 2C9 4 11 8.5 11 12V22H0ZM16 22V12H22C22 8.5 21 6 19 4.5L21 2C25 4 27 8.5 27 12V22H16Z" fill="currentColor"/></svg>';
    article.appendChild(quoteIconBg);

    // Header do card com estrelas e selo verificado
    var cardHeader = document.createElement('div');
    cardHeader.className = 'quote-card-header d-flex align-items-center justify-content-between mb-3';

    var stars = document.createElement('ul');
    stars.className = 'rating mb-0 d-flex align-items-center';
    stars.setAttribute('aria-label', data.rating + ' de 5');
    for (var i = 1; i <= 5; i += 1) {
      var li = document.createElement('li');
      if (i <= data.rating) {
        li.className = 'rated';
      }
      li.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 14 12" fill="none"><path d="M6.91566 0L9.04309 3.60776L13.1743 4.49139L10.3579 7.60474L10.7837 11.7586L6.91566 10.075L3.04762 11.7586L3.47342 7.60474L0.657043 4.49139L4.78824 3.60776L6.91566 0Z" fill="currentColor"/></svg>';
      stars.appendChild(li);
    }
    cardHeader.appendChild(stars);

    if (data.verified) {
      var verified = document.createElement('span');
      verified.className = 'quote-verified d-inline-flex align-items-center';
      verified.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" stroke-width="0.8"/><path d="M4.25 6L5.25 7L7.75 4.5" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Compra verificada</span>';
      cardHeader.appendChild(verified);
    }
    article.appendChild(cardHeader);

    appendReviewText(article, 'h3', 'azp-review-title', data.title);
    appendReviewText(article, 'p', 'azp-review-text', data.body);

    var author = document.createElement('div');
    author.className = 'azp-review-author';

    var avatar = document.createElement('span');
    avatar.className = 'azp-review-avatar';
    avatar.textContent = data.initials || 'AZ';
    author.appendChild(avatar);

    var authorDetails = document.createElement('span');
    authorDetails.className = 'quote-author-details';
    appendReviewText(authorDetails, 'span', 'azp-review-name', data.name || 'Cliente Azua');
    appendReviewText(authorDetails, 'span', 'azp-review-city', data.city || '');
    author.appendChild(authorDetails);

    article.appendChild(author);
    return article;
  }

  function judgemeAggregate(source, reviewEls) {
    var widg = source.querySelector('.jdgm-rev-widg');

    var count = widg ? Number(widg.getAttribute('data-number-of-reviews')) : 0;
    if (!count || !isFinite(count)) count = reviewEls.length;

    // O data-average-rating do Judge.me as vezes vem 0.00 num widget secundario da pagina;
    // se nao for confiavel, calculamos a media a partir das estrelas reais das avaliacoes.
    var average = widg ? parseFloat(widg.getAttribute('data-average-rating')) : NaN;
    if (!average || !isFinite(average)) {
      var sum = 0;
      var counted = 0;
      reviewEls.forEach(function(review) {
        var rating = parseJudgemeRating(review);
        if (rating) { sum += rating; counted += 1; }
      });
      average = counted ? sum / counted : 0;
    }

    return { count: count, average: average };
  }

  function updateReviewAggregate(section, agg) {
    var wrap = section ? section.querySelector('[data-azp-review-agg]') : null;
    if (!wrap) return;

    if (!agg || !agg.count) {
      wrap.hidden = true;
      return;
    }

    var numberEl = wrap.querySelector('[data-azp-agg-number]');
    if (numberEl) numberEl.textContent = agg.average.toFixed(1).replace('.', ',');

    var rounded = Math.round(agg.average);
    var starsWrap = wrap.querySelector('[data-azp-agg-stars]');
    if (starsWrap) {
      starsWrap.setAttribute('aria-label', agg.average.toFixed(1) + ' de 5');
      Array.prototype.slice.call(starsWrap.querySelectorAll('li')).forEach(function(li, index) {
        li.classList.toggle('rated', index < rounded);
      });
    }

    var copyEl = wrap.querySelector('[data-azp-agg-copy]');
    if (copyEl) {
      copyEl.textContent = 'de 5.0 · ' + agg.count + ' ' + (agg.count === 1 ? 'avaliação' : 'avaliações');
    }

    wrap.hidden = false;
  }

  function hydrateJudgemeReviews(carousel) {
    if (carousel.dataset.azpJudgemeHydrated === 'true') return false;

    var section = carousel.closest('.azp-reviews') || carousel.parentElement;
    var source = section ? section.querySelector('[data-azp-judgeme-source]') : null;
    var track = carousel.querySelector('[data-azp-review-track]');
    if (!source || !track) return false;

    var maxReviews = Number(carousel.dataset.azpMaxReviews || 6);
    var reviews = Array.prototype.slice.call(source.querySelectorAll('.jdgm-rev')).filter(function(review) {
      return !review.classList.contains('jdgm-rev--reply');
    });
    if (!reviews.length) return false;

    var fragment = document.createDocumentFragment();
    var count = 0;
    reviews.slice(0, maxReviews).forEach(function(review) {
      var data = judgemeReviewData(review);
      if (!data) return;
      fragment.appendChild(buildReviewCard(data));
      count += 1;
    });

    if (!count) return false;
    track.innerHTML = '';
    track.appendChild(fragment);
    carousel.dataset.azpJudgemeHydrated = 'true';
    updateReviewAggregate(section, judgemeAggregate(source, reviews));

    var actions = section.querySelector('[data-azp-review-actions]');
    if (actions) actions.hidden = false;

    return true;
  }

  function ensureReviewBackButton(reviewsRoot, source) {
    if (reviewsRoot.querySelector('[data-azp-review-back]')) return;
    var bar = document.createElement('div');
    bar.className = 'azp-review-native-back';
    bar.setAttribute('data-azp-review-back', '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'azp-review-cta azp-review-cta--ghost';
    btn.textContent = '← Voltar às avaliações';
    btn.addEventListener('click', function() {
      reviewsRoot.classList.remove('azp-reviews--native');
    });
    bar.appendChild(btn);
    source.parentNode.insertBefore(bar, source);
  }

  function openJudgemeReviewForm(reviewsRoot) {
    var source = reviewsRoot.querySelector('[data-azp-judgeme-source]');
    if (!source) return;

    // Dispara o link real "escrever avaliacao" do Judge.me (esta com display:none no HTML).
    var link = source.querySelector('.jdgm-write-rev-link');
    if (link) {
      try { link.click(); } catch (error) {}
    }

    // Se o Judge.me abrir seu proprio modal, nao mexemos no layout. Se ele injeta o form
    // inline (dentro da nossa fonte escondida), revelamos o widget nativo para ficar usavel.
    setTimeout(function() {
      var modal = document.querySelector('.jdgm-modal, .jdgm-form-modal, [class*="jdgm"][class*="modal"]');
      if (modal) return;

      reviewsRoot.classList.add('azp-reviews--native');
      if (link) link.style.display = 'inline-block';
      ensureReviewBackButton(reviewsRoot, source);
      source.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 350);
  }

  function initReviewWriteButtons(reviewsRoot) {
    Array.prototype.slice.call(reviewsRoot.querySelectorAll('[data-azp-review-write]')).forEach(function(btn) {
      if (btn.dataset.azpWriteBound === 'true') return;
      btn.dataset.azpWriteBound = 'true';
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        openJudgemeReviewForm(reviewsRoot);
      });
    });
  }

  function initReviewCarousels(scope) {
    scope.querySelectorAll('[data-azp-review-carousel]').forEach(function(carousel) {
      if (carousel.dataset.azpReviewReady === 'true') return;
      carousel.dataset.azpReviewReady = 'true';

      var reviewsRoot = carousel.closest('.azp-reviews');
      if (reviewsRoot) initReviewWriteButtons(reviewsRoot);

      var viewport = carousel.querySelector('[data-azp-review-viewport]');
      var track = carousel.querySelector('[data-azp-review-track]');
      var nav = carousel.querySelector('[data-azp-review-nav]');
      var prev = carousel.querySelector('[data-azp-review-prev]');
      var next = carousel.querySelector('[data-azp-review-next]');
      var dots = carousel.querySelector('[data-azp-review-dots]');
      var empty = carousel.querySelector('[data-azp-review-empty]');
      var active = 0;
      var pages = 1;
      var perView = 3;
      var resizeTimer;

      if (!viewport || !track) return;

      function getPerView() {
        if (window.matchMedia('(max-width: 749px)').matches) return 1;
        if (window.matchMedia('(max-width: 989px)').matches) return 2;
        return 3;
      }

      function currentCards() {
        return Array.prototype.slice.call(track.querySelectorAll('[data-azp-review-card]'));
      }

      function renderDots() {
        if (!dots) return;
        dots.innerHTML = '';
        for (var i = 0; i < pages; i += 1) {
          var dot = document.createElement('button');
          dot.className = 'azp-review-dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Ir para grupo de avaliacoes ' + (i + 1));
          dot.dataset.azpReviewDot = i;
          dot.addEventListener('click', function() {
            active = Number(this.dataset.azpReviewDot);
            update();
          });
          dots.appendChild(dot);
        }
      }

      function update() {
        var cards = currentCards();
        if (!cards.length) {
          track.style.transform = '';
          if (empty) empty.hidden = false;
          if (nav) nav.hidden = true;
          return;
        }

        if (empty) empty.hidden = true;

        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        var cardWidth = cards[0].getBoundingClientRect().width;
        var maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
        var offset = Math.min(active * perView * (cardWidth + gap), maxOffset);

        track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';

        if (nav) nav.hidden = pages <= 1;
        if (prev) prev.disabled = active <= 0;
        if (next) next.disabled = active >= pages - 1;
        if (dots) {
          dots.querySelectorAll('[data-azp-review-dot]').forEach(function(dot, index) {
            dot.classList.toggle('is-active', index === active);
          });
        }
      }

      function refresh() {
        var cards = currentCards();
        perView = Math.min(getPerView(), Math.max(cards.length, 1));
        pages = Math.max(1, Math.ceil(cards.length / perView));
        active = Math.min(active, pages - 1);
        renderDots();
        update();
      }

      function watchJudgeme(attempt) {
        if (hydrateJudgemeReviews(carousel)) {
          active = 0;
          refresh();
          return;
        }
        if (attempt < 30) {
          setTimeout(function() { watchJudgeme(attempt + 1); }, 350);
        }
      }

      if (prev) {
        prev.addEventListener('click', function() {
          active = Math.max(0, active - 1);
          update();
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          active = Math.min(pages - 1, active + 1);
          update();
        });
      }

      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refresh, 120);
      });

      refresh();
      watchJudgeme(0);
    });
  }

  function initLook(root) {
    if (!root || root.dataset.azpReady === 'true') return;
    root.dataset.azpReady = 'true';

    var currency = root.dataset.currency || 'BRL';
    var sectionEl = root.closest('[data-section-id]');
    var sectionId = sectionEl ? sectionEl.dataset.sectionId : '';
    var loadingVariantId = '';
    var selected = {}; // productId -> { variantId, price, title, image, current, variantTitle }
    var cards = root.querySelectorAll('[data-azp-look-card]');
    var list = root.querySelector('[data-azp-look-list]');
    var total = root.querySelector('[data-azp-look-total]');
    var desc = root.querySelector('[data-azp-look-desc]');
    var note = root.querySelector('[data-azp-look-note]');
    var addLook = root.querySelector('[data-azp-add-look]');

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[-_]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
    }

    function variantColorKey(variant) {
      var optionIndex = Number(root.dataset.colorOptionIndex || (sectionEl && sectionEl.dataset.colorOptionIndex) || -1);
      if (!variant || optionIndex < 0 || !variant.options || !variant.options.length) return '';
      return normalize(variant.options[optionIndex]);
    }

    function updateCurrentVariantLocally(variantId) {
      var currentCard = root.querySelector('[data-azp-look-card][data-current="true"]');
      if (!currentCard || typeof currentCard._azpSelectVariant !== 'function') return false;
      var updated = currentCard._azpSelectVariant(variantId);
      if (updated) {
        root.dataset.currentVariantId = String(variantId);
        if (sectionEl) sectionEl.dataset.currentVariantId = String(variantId);
      }
      return updated;
    }

    function refreshForMainVariant(variantId, variant) {
      if (!sectionEl || !sectionId || !variantId || loadingVariantId === variantId) return;
      if (String(root.dataset.currentVariantId || sectionEl.dataset.currentVariantId || '') === String(variantId)) return;

      // Regra de negocio: troca de tamanho na mesma cor nao deve resetar os complementos escolhidos.
      var currentColorKey = normalize(root.dataset.currentColor || (sectionEl && sectionEl.dataset.currentColor) || root.dataset.currentColorKey || (sectionEl && sectionEl.dataset.currentColorKey) || '');
      var nextColorKey = variantColorKey(variant);
      if (currentColorKey && nextColorKey && currentColorKey === nextColorKey && updateCurrentVariantLocally(variantId)) return;

      loadingVariantId = variantId;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('look section render failed');
          return response.text();
        })
        .then(function(html) {
          var temp = document.createElement('div');
          temp.innerHTML = html.trim();
          var nextSection = temp.querySelector('[data-section-id="' + sectionId + '"]') || temp.firstElementChild;
          if (!nextSection) {
            sectionEl.hidden = true;
            return;
          }
          sectionEl.replaceWith(nextSection);
          if (window.AstPdpSections && typeof window.AstPdpSections.initAll === 'function') {
            window.AstPdpSections.initAll(nextSection);
          }
        })
        .catch(function(error) {
          console.warn('[Asthros Monte Look] Nao foi possivel atualizar o look da variante.', error);
        })
        .finally(function() {
          loadingVariantId = '';
        });
    }

    function onMainVariantChange(event) {
      if (!document.documentElement.contains(root)) {
        document.removeEventListener('azp:variant:change', onMainVariantChange);
        return;
      }
      var variantId = event.detail && event.detail.variantId;
      refreshForMainVariant(String(variantId || ''), event.detail && event.detail.variant);
    }

    document.addEventListener('azp:variant:change', onMainVariantChange);

    // ---- Abas ----
    var tabs = root.querySelectorAll('[data-azp-tab]');
    var panels = root.querySelectorAll('[data-azp-panel]');

    function buildCarousel(panel) {
      if (!panel || typeof Swiper === 'undefined') return;
      var el = panel.querySelector('[data-azp-carousel]');
      if (!el) return;
      // destrói instância anterior pra remedir do zero (evita layout travado de quando estava hidden)
      if (panel._azpSwiper && !panel._azpSwiper.destroyed) {
        panel._azpSwiper.destroy(true, true);
      }
      panel._azpSwiper = new Swiper(el, {
        slidesPerView: 'auto',
        autoHeight: false,
        freeMode: false,
        freeModeSticky: true,
        centeredSlides: false,
        grabCursor: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        a11y: { enabled: true },
        keyboard: { enabled: true },
        spaceBetween: 16,
        navigation: {
          nextEl: el.querySelector('[data-azp-next]'),
          prevEl: el.querySelector('[data-azp-prev]')
        },
        scrollbar: {
          el: el.querySelector('[data-azp-scrollbar]'),
          draggable: true
        },
        breakpoints: {
          320: { slidesPerView: 'auto', spaceBetween: 12 },
          576: { slidesPerView: 'auto', spaceBetween: 12 },
          768: { slidesPerView: 'auto', spaceBetween: 14 },
          992: { slidesPerView: 'auto', spaceBetween: 16 }
        }
      });
    }

    function initCarousel(panel) {
      if (!panel) return;
      // adia até o painel estar visível e com layout aplicado
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { buildCarousel(panel); });
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          var on = p.getAttribute('data-azp-panel') === tab.getAttribute('data-azp-tab');
          p.classList.toggle('is-active', on);
          p.hidden = !on;
          if (on) initCarousel(p);
        });
      });
    });

    // inicializa carrossel da primeira aba (visível ao carregar)
    var firstPanel = root.querySelector('[data-azp-panel="0"]');
    if (firstPanel) initCarousel(firstPanel);

    function lookDiscount(count) {
      if (count >= 4) return .18;
      if (count >= 2) return .06;
      return 0;
    }

    function addToLook(card) {
      var v = card._azpVariant;
      if (!v || !v.available) return;
      card._azpInLook = true;
      selected[card.dataset.productId] = {
        variantId: v.id, price: v.price, title: card.dataset.title,
        image: v.image || card.dataset.image, current: card.dataset.current === 'true',
        variantTitle: v.title
      };
      card.classList.add('is-selected');
      var btn = card.querySelector('[data-azp-add-item]');
      if (btn) { btn.setAttribute('aria-pressed', 'true'); btn.textContent = 'Remover'; btn.disabled = false; }
      renderLook();
    }

    function removeFromLook(card) {
      card._azpInLook = false;
      delete selected[card.dataset.productId];
      card.classList.remove('is-selected');
      var btn = card.querySelector('[data-azp-add-item]');
      if (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.textContent = 'Adicionar peca';
        btn.disabled = !(card._azpVariant && card._azpVariant.available);
      }
      renderLook();
    }

    // Card "esta peca" e o proprio produto: refletir a troca de variante no seletor
    // principal do Asthros Theme reaproveita a cadeia nativa (slate.Variants -> galeria, preco,
    // add-to-cart) + a IIFE de estoque + a ponte azp:variant:change que re-renderiza o look.
    function syncMainVariant(variant) {
      if (!variant || !variant.options || !variant.options.length) return false;
      var changed = [];
      variant.options.forEach(function(value, index) {
        var radios = document.querySelectorAll('input.single-option-selector__radio[data-index="option' + (index + 1) + '"]');
        Array.prototype.forEach.call(radios, function(radio) {
          if (String(radio.value) === String(value) && !radio.checked) {
            radio.checked = true;
            changed.push(radio);
          }
        });
      });
      changed.forEach(function(radio) {
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return changed.length > 0;
    }

    function initCard(card) {
      var variants = [];
      var dataEl = card.querySelector('[data-azp-variants]');
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var optionCount = (JSON.parse(card.dataset.options || '[]')).length;
      var inputs = card.querySelectorAll('input[type="radio"]');
      var addBtn = card.querySelector('[data-azp-add-item]');
      var priceEl = card.querySelector('[data-azp-card-price]');
      var sel = {}; // position -> value
      card._azpVariant = null;
      card._azpInLook = false;
      card._azpVariants = variants;

      inputs.forEach(function(i) { if (i.checked) sel[i.dataset.position] = i.value; });

      function resolve() {
        if (Object.keys(sel).length < optionCount) { card._azpVariant = null; return; }
        card._azpVariant = variants.filter(function(v) {
          return v.options.every(function(opt, idx) { return sel[idx + 1] === opt; });
        })[0] || null;
      }
      function refreshAvail() {
        inputs.forEach(function(input) {
          var pos = Number(input.dataset.position);
          var ok = variants.some(function(v) {
            if (!v.available) return false;
            if (v.options[pos - 1] !== input.value) return false;
            return Object.keys(sel).every(function(p) {
              if (Number(p) === pos) return true;
              return v.options[Number(p) - 1] === sel[p];
            });
          });
          input.disabled = !ok;
        });
      }
      function updateUI() {
        var v = card._azpVariant;
        if (priceEl) priceEl.textContent = money(v ? v.price : card.dataset.basePrice, currency);
        if (v && v.image) {
          card.dataset.image = v.image;
          var imageEl = card.querySelector('.azp-look-image img');
          if (imageEl && imageEl.getAttribute('src') !== v.image) imageEl.setAttribute('src', v.image);
        }
        if (addBtn && !card._azpInLook) addBtn.disabled = !(v && v.available);
      }
      function selectVariant(variantId) {
        var next = variants.filter(function(v) { return String(v.id) === String(variantId); })[0] || null;
        if (!next) return false;
        next.options.forEach(function(value, index) { sel[index + 1] = value; });
        inputs.forEach(function(input) {
          input.checked = String(sel[input.dataset.position]) === String(input.value);
        });
        resolve(); refreshAvail(); updateUI();
        if (card.dataset.current === 'true') {
          delete selected[card.dataset.productId];
          card._azpInLook = false;
          if (card._azpVariant && card._azpVariant.available) addToLook(card);
          else renderLook();
        } else if (card._azpInLook) {
          if (card._azpVariant && card._azpVariant.available) addToLook(card);
          else removeFromLook(card);
        }
        return true;
      }
      card._azpSelectVariant = selectVariant;

      if (variants.length === 1) { sel[1] = variants[0].options[0]; }
      resolve(); refreshAvail(); updateUI();

      inputs.forEach(function(input) {
        input.addEventListener('change', function() {
          sel[input.dataset.position] = input.value;
          resolve(); refreshAvail(); updateUI();
          if (card.dataset.current === 'true' && syncMainVariant(card._azpVariant)) return;
          if (card._azpInLook) {
            if (card._azpVariant && card._azpVariant.available) addToLook(card);
            else removeFromLook(card);
          }
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          if (card._azpInLook) removeFromLook(card);
          else addToLook(card);
        });
      }

      // peca atual entra pre-adicionada
      if (card.dataset.current === 'true' && card._azpVariant) addToLook(card);
    }

    cards.forEach(initCard);

    function renderLook() {
      var ids = Object.keys(selected);
      var items = ids.map(function(id) { return selected[id]; });
      var subtotal = items.reduce(function(s, it) { return s + Number(it.price || 0); }, 0);
      var discount = lookDiscount(items.length);
      var finalTotal = Math.round(subtotal - subtotal * discount);

      if (list) {
        list.innerHTML = '';
        items.forEach(function(it, idx) {
          var row = document.createElement('div'); row.className = 'azp-panel-item';
          if (it.image) { var im = document.createElement('img'); im.src = it.image; im.alt = ''; row.appendChild(im); }
          else { var em = document.createElement('span'); em.className = 'azp-panel-img-empty'; row.appendChild(em); }
          var info = document.createElement('span'); info.className = 'azp-panel-info';
          var name = document.createElement('span'); name.className = 'azp-panel-name'; name.textContent = it.title || ''; info.appendChild(name);
          if (it.variantTitle && it.variantTitle !== 'Default Title') {
            var meta = document.createElement('span'); meta.className = 'azp-panel-meta'; meta.textContent = it.variantTitle; info.appendChild(meta);
          }
          row.appendChild(info);
          var price = document.createElement('span'); price.className = 'azp-panel-price'; price.textContent = money(it.price, currency); row.appendChild(price);
          if (!it.current) {
            var rm = document.createElement('button'); rm.className = 'azp-panel-remove'; rm.type = 'button';
            rm.dataset.remove = ids[idx]; rm.textContent = 'x'; row.appendChild(rm);
          }
          list.appendChild(row);
        });
        list.querySelectorAll('[data-remove]').forEach(function(button) {
          button.addEventListener('click', function() {
            var card = root.querySelector('[data-azp-look-card][data-product-id="' + button.dataset.remove + '"]');
            if (card) removeFromLook(card);
          });
        });
      }

      if (total) total.textContent = money(finalTotal, currency);
      if (desc) desc.textContent = items.length + ' peca' + (items.length > 1 ? 's' : '') + (discount ? ' \u00b7 ' + Math.round(discount * 100) + '% off' : '');
      if (note) note.textContent = items.length >= 2 ? 'Desconto aplicado automaticamente na sacola.' : 'Selecione ao menos 2 pecas';
      if (addLook) addLook.disabled = items.length < 2;
    }

    if (addLook) {
      addLook.addEventListener('click', function() {
        var items = Object.keys(selected).map(function(id) { return { id: Number(selected[id].variantId), quantity: 1 }; });
        if (items.length < 2) return;
        addLook.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function(response) {
            if (!response.ok) throw new Error('look add failed');
            return response.json();
          })
          .then(function() {
            if (window.theme && theme.miniCart) {
              if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
              if (typeof theme.miniCart.updateElements === 'function') theme.miniCart.updateElements();
            }
            toast(root, 'Look adicionado');
            addLook.disabled = false;
          })
          .catch(function() {
            toast(root, 'Nao foi possivel adicionar');
            addLook.disabled = false;
          });
      });
    }

    renderLook();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-azp-hero]').forEach(initHero);
    initAccordions(scope);
    initCarousels(scope);
    initReviewCarousels(scope);
    scope.querySelectorAll('[data-azp-look]').forEach(initLook);
  }

  window.AstPdpSections = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();

/* Countdown do bloco "Estoque limitado" (Asthros PDP overview) */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdowns() {
    var els = document.querySelectorAll('[data-asthros-countdown]');
    els.forEach(function (el) {
      if (el._asthrosCd) return;
      el._asthrosCd = true;
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var timeEl = el.querySelector('[data-cd-time]');
      if (!timeEl) return;
      // persiste o deadline por sessão para não reiniciar a cada navegação
      var key = 'asthros_cd_' + minutes;
      var deadline = sessionStorage.getItem(key);
      var now = Date.now();
      if (!deadline || parseInt(deadline, 10) < now) {
        deadline = now + minutes * 60 * 1000;
        try { sessionStorage.setItem(key, String(deadline)); } catch (e) {}
      } else {
        deadline = parseInt(deadline, 10);
      }
      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          timeEl.textContent = '00:00';
          clearInterval(el._asthrosTimer);
          return;
        }
        var totalSec = Math.floor(diff / 1000);
        var m = Math.floor(totalSec / 60);
        var s = totalSec % 60;
        timeEl.textContent = pad(m) + ':' + pad(s);
      }
      tick();
      el._asthrosTimer = setInterval(tick, 1000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }
  // reinit em troca de variante / re-render do tema
  document.addEventListener('shopify:section:load', initCountdowns);
})();
